import { deserialize, serializable } from 'serializr';
import { Base } from './base.model';
import { PageObject } from './page-object.model';

export class RuntimeVariable extends Base implements PageObject {
  @serializable
  public testStepId: number;

  @serializable
  public name: string;

  @serializable
  public lastUsedValue: string;

  @serializable
  public stepPosition: number;

  @serializable
  public applicationVersionId: number;

  @serializable
  public usageCount: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(RuntimeVariable, input));
  }
}
